import React from 'react';
import { Database, Layers, Bot, ShieldCheck, Calculator, HardDrive } from 'lucide-react';
import { cn } from '@/lib/utils';

export type DataSource =
  | 'PROCUREAI'
  | 'SAP'
  | 'AI GENERATED'
  | 'APPROVAL SYSTEM'
  | 'CALCULATED'
  | 'MASTER DATA';

interface SourceBadgeProps {
  source: DataSource;
  className?: string;
  showIcon?: boolean;
}

export const SourceBadge: React.FC<SourceBadgeProps> = ({ source, className, showIcon = true }) => {
  let labelText: string = source;
  let Icon = Database;
  let styleClass = 'bg-teal-500/10 text-teal-700 dark:text-teal-400 border-teal-500/20';

  switch (source) {
    case 'PROCUREAI':
      labelText = 'ProcureAI';
      Icon = Database;
      styleClass = 'bg-primary/10 text-primary border-primary/20 font-semibold';
      break;
    case 'SAP':
      labelText = 'SAP S/4HANA';
      Icon = Layers;
      styleClass = 'bg-sky-500/10 text-sky-700 dark:text-sky-400 border-sky-500/20 font-bold';
      break;
    case 'AI GENERATED':
      labelText = 'AI Generated';
      Icon = Bot;
      styleClass = 'bg-copper/10 text-copper dark:text-amber-400 border-copper/20 font-semibold';
      break;
    case 'APPROVAL SYSTEM':
      labelText = 'Approval System';
      Icon = ShieldCheck;
      styleClass = 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-500/20 font-semibold';
      break;
    case 'CALCULATED':
      labelText = 'Calculated';
      Icon = Calculator;
      styleClass = 'bg-slate-500/10 text-slate-700 dark:text-slate-300 border-slate-500/20 font-medium';
      break;
    case 'MASTER DATA':
      labelText = 'Master Data';
      Icon = HardDrive;
      styleClass = 'bg-stone-500/10 text-stone-700 dark:text-stone-300 border-stone-500/20 font-medium';
      break;
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md border px-2 py-0.5 text-[11px] uppercase tracking-wider transition-all select-none',
        styleClass,
        className
      )}
    >
      {showIcon && <Icon className="h-3 w-3 flex-shrink-0" />}
      <span>{labelText}</span>
    </span>
  );
};
